module.exports = __webpack_public_path__ + "img/right_md_1.93389ded.jpg";